const validateFullName = (name = '') => {
  return name.replace(/[^a-zA-Z\s]/g, '');
};

export default validateFullName;
